module.exports = __webpack_public_path__ + "img/invalidImg.d74e5524.svg";